import "styles/app.scss"

import React from "react"
import { CookiesProvider, withCookies } from "react-cookie"
import { QueryClient, QueryClientProvider } from "react-query"
import clsx from "clsx"

import LocaleProvider from "context/locale"
import WindowProvider from "context/window"

import { Header, Footer } from "./components"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const Layout = ({
  children,
  location,
  services,
  translations,
  hasTraderWidget,
}) => {
  return (
    <LocaleProvider location={location} translations={translations}>
      <QueryClientProvider client={queryClient}>
        <WindowProvider>
          <CookiesProvider>
            <Header services={services} />
            <main className={clsx(hasTraderWidget && "trader-widget-wrapper")}>
              {children}
            </main>
            <Footer services={services} />
          </CookiesProvider>
        </WindowProvider>
      </QueryClientProvider>
    </LocaleProvider>
  )
}

export default withCookies(Layout)
